export default __webpack_public_path__ + "static/austin-circle@2x-87ee8e45fcaea97a23f31534db13bb33.png";